import {getMethod, postMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/hotelDescription/${hotelId}/mealType`, request)
}

async function post(hotelId, request) {
    return await postMethod(`/api/hotelDescription/${hotelId}/mealType`, request)
}

async function put(hotelId, mealTypeId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/mealType/${mealTypeId}`, request)
}

export {get, post, put}
